function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { getReportTemplateOptions } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS, EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS } from '@rd-web-markets/market/dist/constants';
import ReviewableFieldEditorWithAutomaticUpdates from '@rd-web-markets/shared/dist/util/textEdit/ReviewableFieldEditorWithAutomaticUpdates';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useSelector } from 'react-redux';
import OnlyCommentsEditor from '@rd-web-markets/shared/dist/util/textEdit/OnlyCommentsEditor';
import reportTemplateCategoryService from '../../services/report_templates/report_template_category.service';
import reportTemplateService from '../../services/report_template.service';
export default function EditReportTemplateCategoryModal(_ref) {
  let {
    reportTemplateId,
    reportTemplateCategoryId = null,
    onHide,
    onContentChanged,
    isVisible,
    title,
    isUnderReview = false,
    footnoteStartIndex = 0
  } = _ref;
  const [rndReportTemplate, setRndReportTemplate] = useState(null);
  const [reportTemplateCategory, setReportTemplateCategory] = useState(null);
  const [closeButtonLoading, setCloseButtonLoading] = useState(false);
  const user = useSelector(state => state.auth.user);
  const showTrackChangesControls = user.account_type !== 'customer';
  const updateReportTemplateCagegory = useErrorHandling(useCallback(async updatedValue => {
    const updatedReportTemplateCategory = await reportTemplateCategoryService.update(reportTemplateId, _objectSpread(_objectSpread({}, reportTemplateCategory), updatedValue));
    setReportTemplateCategory(_objectSpread({}, updatedReportTemplateCategory));
    return updatedReportTemplateCategory;
  }, [reportTemplateCategoryService, reportTemplateCategory, reportTemplateId]));
  const onStylesFormatterToggled = async should_apply_styles => {
    const updatedReportTemplateCategory = await updateReportTemplateCagegory({
      should_apply_styles
    });
    return updatedReportTemplateCategory.should_apply_styles;
  };
  const getCommonEditorModulesSettings = reportTemplateCategory => ({
    stylesFormatterToggleIniitialValue: reportTemplateCategory === null || reportTemplateCategory === void 0 ? void 0 : reportTemplateCategory.should_apply_styles,
    onStylesFormatterToggled,
    footnoteStartIndex
  });
  const fetchData = useErrorHandling(useCallback(async () => {
    const rndReportTemplate = await reportTemplateService.get(reportTemplateId);
    setRndReportTemplate(rndReportTemplate);
    const reportTemplateCategory = await reportTemplateCategoryService.get(reportTemplateId, reportTemplateCategoryId);
    setReportTemplateCategory(reportTemplateCategory);
  }, [reportTemplateCategoryId, reportTemplateId]));
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const updateContentFn = useCallback(async content => {
    const updatedReportTemplateCategory = await reportTemplateCategoryService.update(reportTemplateId, _objectSpread(_objectSpread({}, reportTemplateCategory), {}, {
      content
    }));
    return updatedReportTemplateCategory.content;
  }, [reportTemplateCategory, reportTemplateId]);
  const getContentFn = useCallback(async () => {
    const rndReportTemplate = await reportTemplateService.get(reportTemplateId);
    setRndReportTemplate(rndReportTemplate);
    const reportTemplateCategory = await reportTemplateCategoryService.get(reportTemplateId, reportTemplateCategoryId);
    setReportTemplateCategory(reportTemplateCategory);
    return reportTemplateCategory.content;
  }, [reportTemplateCategoryId, reportTemplateId]);
  const onUpdateContentFn = useCallback(() => {
    setCloseButtonLoading(false);
  }, []);
  const editorInitConfig = useMemo(() => {
    if (!rndReportTemplate) {
      return {};
    }
    return getReportTemplateOptions(rndReportTemplate, EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS, EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS, _objectSpread({}, getCommonEditorModulesSettings(reportTemplateCategory)));
  }, [rndReportTemplate, reportTemplateCategory]);
  const trackChangesEditorInitFn = useCallback(addCommentCallback => {
    if (!rndReportTemplate) {
      return {};
    }
    return getReportTemplateOptions(rndReportTemplate, EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS, EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS, _objectSpread({
      isTrackingChanges: true,
      onAddCommentButtonClickCallback: addCommentCallback,
      showTrackChangesControls: showTrackChangesControls
    }, getCommonEditorModulesSettings(reportTemplateCategory)));
  }, [rndReportTemplate, showTrackChangesControls, reportTemplateCategory]);
  const onTrackChangesCreateComment = useCallback(() => {
    setCloseButtonLoading(true);
  }, []);
  const onEditorChange = useCallback(() => {
    setCloseButtonLoading(true);
  }, []);
  const editReportTemplateCategoryModalBody = () => {
    var _rndReportTemplate$cl, _rndReportTemplate$cl2;
    if (!rndReportTemplate || !reportTemplateCategory) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, user.account_type === 'customer' && !(rndReportTemplate !== null && rndReportTemplate !== void 0 && (_rndReportTemplate$cl = rndReportTemplate.claim_group.active_change_set) !== null && _rndReportTemplate$cl !== void 0 && _rndReportTemplate$cl.finalized_at) && /*#__PURE__*/React.createElement(OnlyCommentsEditor, {
      getContentFn: getContentFn,
      updateContentFn: updateContentFn,
      modelClass: "ReportTemplateCategory",
      modelId: reportTemplateCategory.id,
      modelField: 'content'
    }), user.account_type === 'customer' && !!(rndReportTemplate !== null && rndReportTemplate !== void 0 && (_rndReportTemplate$cl2 = rndReportTemplate.claim_group.active_change_set) !== null && _rndReportTemplate$cl2 !== void 0 && _rndReportTemplate$cl2.finalized_at) && /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: reportTemplateCategory.content
      }
    }), user.account_type !== 'customer' && /*#__PURE__*/React.createElement(ReviewableFieldEditorWithAutomaticUpdates, {
      isUnderReview: isUnderReview,
      modelClass: "ReportTemplateCategory",
      modelId: reportTemplateCategory.id,
      modelField: 'content',
      getContentFn: getContentFn,
      updateContentFn: updateContentFn,
      onUpdateContentFn: onUpdateContentFn,
      editorInitConfig: editorInitConfig,
      trackChangesOnCreateComment: onTrackChangesCreateComment,
      trackChangesEditoInitFn: trackChangesEditorInitFn,
      onEditorChange: onEditorChange,
      showTrackChangesControls: showTrackChangesControls
    })));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: title || 'Edit text',
    show: isVisible,
    renderBody: editReportTemplateCategoryModalBody,
    onHide: onContentChanged,
    closeButtonLoading: closeButtonLoading,
    disabled: closeButtonLoading,
    closeText: "Save"
  });
}